import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    id: "overview",
    title: "Overview",
    body: [
      "Every contribution to AvdheshanandG Mission is received as seva and directed to the mission's charitable work. Because donations are voluntary gifts that are promptly committed to programs, they are generally non-refundable.",
    ],
  },
  {
    id: "genuine-errors",
    title: "When a refund is considered",
    body: [
      "We honour genuine errors. If you were charged in error — a duplicate transaction, an incorrect amount, or a payment you did not authorise — please write to us within 7 days of the charge.",
      "Verified errors are refunded in full to the original payment method, normally within 5–7 business days. Your bank or card issuer may take additional time to reflect the refund.",
    ],
  },
  {
    id: "monthly-seva",
    title: "Monthly seva (recurring giving)",
    body: [
      "You may cancel a monthly contribution at any time using the secure link included in every acknowledgement email — no account or login is required. Cancellation stops all future charges.",
      "A contribution that has already been collected is not reversed, except in the case of a genuine error as described above.",
    ],
  },
  {
    id: "how-to-request",
    title: "How to request a refund",
    body: [
      "Email info@avdheshanandgmission.org with your receipt number and the details of the charge. We will respond and, where a refund is due, process it promptly.",
    ],
  },
  {
    id: "note",
    title: "A note",
    body: [
      "This policy is offered in good faith and does not limit any rights you may have under applicable law.",
    ],
  },
];

export default function RefundPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#fcf9f5] to-white">
      <div className="relative flex h-[44vh] items-center justify-center overflow-hidden bg-[#7B0000] text-white">
        <div className="relative z-20 px-4 text-center">
          <h1 className="mb-4 mt-7 font-serif text-4xl md:text-6xl">Refund &amp; Cancellation Policy</h1>
          <p className="mx-auto max-w-3xl text-lg font-light md:text-2xl">
            How contributions, errors and monthly seva are handled.
          </p>
        </div>
        <div className="absolute bottom-4 right-4 z-10 font-serif text-6xl text-white/20">ॐ</div>
      </div>

      <div className="container mx-auto px-4 py-8">
        <a
          href="/"
          className="mb-8 inline-flex items-center text-[#B82A1E] transition-colors duration-300 hover:text-[#8a1f16]"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to home
        </a>

        <div className="mx-auto max-w-3xl space-y-10 pb-16">
          {sections.map(section => (
            <section key={section.id} id={section.id}>
              <h2 className="mb-3 text-2xl font-semibold text-[#14201f]">{section.title}</h2>
              {section.body.map((p, i) => (
                <p key={i} className="mb-3 text-base leading-8 text-[#52615f]">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
